import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
export var CheckboxLabel = styled("label")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: inline-flex;\n    align-items: flex-start;\n"])));
//# sourceMappingURL=CheckboxLabel.js.map